module.exports = __webpack_public_path__ + "img/alur-pendaftaran-paten-sederhana.c8c7db8a.png";